import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import {PhotoData} from '@employee-pages/badge-request-page/employee-badge-requests';


@Component({
    selector: 'employee-take-photo-mobile',
    templateUrl: './employee-take-photo-mobile.component.html',
    styleUrls: ['./employee-take-photo-mobile.component.less']
})
export class EmployeeTakePhotoMobileComponent {

    @Input() canUseCurrentImage: boolean;
    @Input() photoData: PhotoData;
    @Input() userPhotoUrl: string = null;
    @Input() newFileName: string = null;
    @Input() requestData: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() uploadConfig: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() cameraConfig: EmployeeModels.DM.IBadgeRequestInfoEmployee;
    @Input() isVisitorRequest = false;

    @Output() onTakePhoto = new EventEmitter<PhotoData>();
    @Output() onDelete = new EventEmitter<void>();
    @Output() onUseCurrentPhoto = new EventEmitter<PhotoData>();
    @Output() onUpload = new EventEmitter<PhotoData>();

    onPhotoTaken(event: PhotoData): void {
        this.onTakePhoto.emit(event);
    }

    deletePhoto(): void {
        this.onDelete.emit();
    }

    useCurrentPhoto(): void {
        this.onUseCurrentPhoto.emit();
    }

    onPhotoUploaded(event: PhotoData[]): void {
        this.onUpload.emit(event[0]);
    }

}
